import { render, staticRenderFns } from "./TgContentList.vue?vue&type=template&id=614c5010&"
import script from "./TgContentList.vue?vue&type=script&lang=js&"
export * from "./TgContentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports